/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
/* stylelint-disable selector-no-qualifying-type */
/**
@prop --ux-file-upload-item-default-widt: Item default width
@prop --ux-file-upload-item-min-width: Item min width
@prop --ux-file-upload-item-max-Width: Items max width
@prop --ux-file-upload-spacing: Item spacing
@prop --ux-file-upload-items-per-row: Items per row
@prop --ux-file-upload-item-alignment: Item alignment
*/
.ux-file-upoad {
  display: block;
  position: relative;
}

.ux-file-upload--error .ux-file-upload__container {
  border: 1px solid #ff0201;
}
.ux-file-upload--error .ux-file-upload__add-file {
  border-color: #ff0201;
}
.ux-file-upload--error .ux-file-upload__add-file svg {
  fill: #ff0201;
}

.ux-file-upload--disabled {
  pointer-events: none;
}
.ux-file-upload--disabled .ux-file-upload__container {
  opacity: 0.2;
}

.ux-label {
  font-family: Frutiger-Bold, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  display: inline-block;
  font-size: 13px;
  min-width: 0;
  text-transform: uppercase;
}

.ux-label--message {
  font-family: Frutiger-Light, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
}

.ux-label--error {
  font-family: Frutiger-Light, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  color: #ff0201;
}

.ux-file-upload__file-container {
  display: none;
  pointer-events: none;
}

.ux-file-upload__container {
  border: 1px solid #e2e2e2;
  cursor: pointer;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: var(--ux-file-upload-item-alignment);
  padding: var(--ux-file-upload-spacing);
  position: relative;
  width: 100%;
}

.ux-file-upload__container--items-per-row .ux-file-upload__thumbnail-container,
.ux-file-upload__container--items-per-row .ux-file-upload__action-container {
  width: calc(100% / var(--ux-file-upload-items-per-row) - 30px);
}

.ux-file-upload__container--bulk-delete .ux-file-upload__add-file--with-thumbnails {
  width: 50%;
  margin-right: var(--ux-file-upload-spacing);
}
.ux-file-upload__container--bulk-delete .ux-file-upload__delete-all {
  width: 50%;
  margin-left: var(--ux-file-upload-spacing);
}

.ux-file-upload__container:hover {
  border: 1px solid #bbd03a;
}

.ux-file-upload__thumbnail-container {
  width: var(--ux-file-upload-item-default-width);
  min-width: var(--ux-file-upload-item-min-width);
  max-width: var(--ux-file-upload-item-max-width);
  margin: var(--ux-file-upload-spacing);
  position: relative;
  position: relative;
}
.ux-file-upload__thumbnail-container::before {
  display: block;
  content: "";
  width: 100%;
  padding-top: 56.25%;
}

.ux-file-upload__action-container {
  width: var(--ux-file-upload-item-default-width);
  min-width: var(--ux-file-upload-item-min-width);
  max-width: var(--ux-file-upload-item-max-width);
  margin: var(--ux-file-upload-spacing);
  position: relative;
  position: relative;
}
.ux-file-upload__action-container::before {
  display: block;
  content: "";
  width: 100%;
  padding-top: 56.25%;
}

.ux-file-upload__action-container-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  position: absolute;
}

.ux-file-upload__add-file {
  width: 100%;
  height: 100%;
  align-items: center;
  border: 1px dashed #131313;
  display: flex;
  justify-content: center;
  pointer-events: none;
  position: relative;
  transition: all 0.3s ease-in-out;
}
.ux-file-upload__add-file .ux-icon {
  font-size: 12px;
  margin: 0;
  transform: rotate(45deg);
  transition: transform 0.1s ease-in-out;
}

.ux-file-upload__delete-all {
  width: 100%;
  height: 100%;
  padding: 0;
  align-items: center;
  background-color: #fff;
  border: 1px dashed #131313;
  cursor: pointer;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 1;
}
.ux-file-upload__delete-all .ux-icon {
  font-size: 18px;
}

.ux-file-upload__label {
  cursor: pointer;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  position: absolute;
}

.ux-file-upload__input-field {
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  overflow: hidden;
  position: absolute !important;
  width: 1px;
}